<template>
  <div class="content">
    <div class="columns is-centered is-gapless" style="margin-top: 3rem;">
      <div class="column is-4">
        <div class="box">
          <h2 class="is-title is-bold has-text-centered has-text-primary">
            Reset Password
          </h2>
          <hr></hr>
          <form>
            <div class="field">
              <label class="label">New Password</label>
              <p class="control has-icon">
                <input v-model="password" class="input" type="password">
                <span class="icon is-small">
                  <i class="fa fa-key"></i>
                </span>
              </p>
              <p class="help">Password should be minimum 8 characters which contain at least one numeric digit and a special character.</p>
            </div>
            <div class="field">
              <label class="label">Retype Password</label>
              <p class="control has-icon">
                <input v-model="rePassword" class="input" type="password">
                <span class="icon is-small">
                  <i class="fa fa-key"></i>
                </span>
              </p>
            </div>

            <p class="control has-text-centered" style="margin-top: 1rem;">
              <button type="button" class="button is-primary" v-on:click="submitForm()">
                Submit
              </button>
            </p> 
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import router from '../../router'
export default {
  data () {
    return {
      password: '',
      rePassword: ''
    }
  },
  methods: {
    validatePassword (password) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/
      return re.test(password)
    },
    submitForm () {
      var path = this.$route.path
      path = path.split('/')
      console.log(path[path.length - 1])
      var token = path[path.length - 1]
      if (this.password === '') {
        this.$noty.error('Password can not be blank')
      } else if (!this.validatePassword(this.password)) {
        this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.')
      } else if (this.rePassword === '') {
        this.$noty.error('Retype Password can not be blank')
      } else if (this.password !== this.rePassword) {
        this.$noty.error('Password did not match')
        this.password = ''
        this.rePassword = ''
      } else {
        axios.post(globalConstants.apiURL + '/api/v1/resetPassword/' + token, {password: this.password})
        .then(response => {
          if (response.data.error) {
            this.$noty.error(response.data.error)
          } else {
            this.password = ''
            this.rePassword = ''
            this.$noty.success('Password changed successfully.')
            router.push({ path: '/login' })
          }
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?6f3d254f